import {
  adjust,
  complement,
  compose,
  filter,
  fromPairs,
  isEmpty,
  map,
  replace,
  split,
} from 'ramda';

export default compose(
  fromPairs,
  map(adjust(-1, decodeURIComponent)),
  map(split('=')),
  filter(complement(isEmpty)),
  split('&'),
  replace(/^\?/, ''),
);
